export default __webpack_public_path__ + "static/media/sounds/ready_screen_common.mp3";